import { ErrorMessage } from '@/components/errors/ErrorMessage';
import { strings } from '@/services/translation/strings';
import { WorkingShift } from '@/types/daily.types';
import { WorkingRoster } from '@/types/roster.types';
import { FC, useCallback } from 'react';
import { TemplateShift } from './TemplateShift';

interface Props {
  workingTemplate: WorkingRoster;
  setWorkingTemplate: (template: WorkingRoster) => void;
}

export const TemplateShifts: FC<Props> = ({ workingTemplate, setWorkingTemplate }) => {
  const updateShift = useCallback(
    (shiftIndex: number) => (newShift: WorkingShift) => {
      const currentShift = workingTemplate.shifts[shiftIndex];
      if (JSON.stringify(currentShift) === JSON.stringify(newShift)) {
        return;
      }

      const shifts = [...workingTemplate.shifts];
      shifts.splice(shiftIndex, 1, {
        ...currentShift,
        ...newShift
      });

      setWorkingTemplate({ ...workingTemplate, shifts });
    },
    [setWorkingTemplate, workingTemplate]
  );

  const removeShift = useCallback(
    (shiftIndex: number) => () => {
      const shifts = [...workingTemplate.shifts];
      shifts.splice(shiftIndex, 1);
      setWorkingTemplate({ ...workingTemplate, shifts });
    },
    [setWorkingTemplate, workingTemplate]
  );

  if (!workingTemplate) {
    return <ErrorMessage message={strings.common.error} />;
  }

  return (
    <div>
      {workingTemplate.shifts.map((shift, index) => (
        <TemplateShift
          key={shift.id}
          shift={shift}
          updateShift={updateShift(index)}
          removeShift={removeShift(index)}
        />
      ))}
    </div>
  );
};
